import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../services/user/user.service';
import { DocumentService } from '../../services/document/document.service';
import { FormsModule} from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  selector: 'app-multiple-form',
  imports: [CommonModule, FormsModule],
  templateUrl: './multiple-form.component.html',
  styleUrls: ['./multiple-form.component.css']
})
export class MultipleFormComponent {
  templates = [
    { id: 1, name: 'Plantilla 1', icon: '📄' },
    { id: 2, name: 'Plantilla 2', icon: '📝' },
    { id: 3, name: 'Plantilla 3', icon: '📃' },
    { id: 4, name: 'Plantilla 4', icon: '📑' }
  ];
  
  selectedTemplate: number | null = null;
  archivoSeleccionado: File | null = null;
  archivoValido: boolean = false;

  constructor(private userService: UserService, private documentService: DocumentService ,private http: HttpClient) {}

  validarArchivo(event: any) {
    const file = event.target.files[0];
    this.archivoSeleccionado = file;
    this.archivoValido = file && file.name.endsWith('.xlsx');
  }

  isFormularioValido(): boolean {
    return this.archivoValido && this.selectedTemplate !== null;
  }
  


  descargarPlantilla() {
    this.http.get(environment.templateDownloadUrl, { responseType: 'blob' })
      .subscribe((data: Blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(data);
        link.download = 'plantilla.xlsx';
        link.click();
      });
  }

  generarContrato() {
    if (!this.archivoSeleccionado) return;
    this.userService.getUserInfo().subscribe({
      next: (userInfo) => {
        const menuId = String(this.selectedTemplate);
        console.log('ID del menú:', menuId);
        this.documentService.generateBatchDocuments(this.archivoSeleccionado!, menuId, userInfo)
          .subscribe({
            next: (res) => {
              if (res?.url) {
                const a = document.createElement('a');
                a.href = res.url;
                a.download = res.name || 'documentos.zip';
                a.click();
              }
            },
            error: (err) => {
              console.error('Error al generar documentos:', err);
            }
          });
      },
      error: (err) => {
        console.error('Error al obtener info del usuario:', err);
      }
    });
  }

  descargarDocumentos(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'documentos_generados.zip';
    link.click();
  }
}